var exports = {
  "A": "xa15a2ab7--7b9a7e--item",
  "y": "xa15a2ab7--7b9a7e--divider",
};

module.exports = exports;
